export default __webpack_public_path__ + "static/media/1.b65186e5.png";